import {Traitify} from "traitify-widgets";

const traitify = new Traitify();
traitify.http.host = "/traitify-js";
traitify.http.version = null;

export default traitify;
